<template>
  <header class="service-header">
    <div class="service-header-inner">
      <div class="logo-wrapper clickable">
        <img
          :src="logoSrc"
          alt="logo"
          @click="toServiceTop()" />
      </div>
      <nav class="nav-wrapper pc">
        <ul>
          <li
            @click="routerPush('serviceAbout')"
            :class="{ 'active': currentServiceMenu === 'serviceAbout' }"
          >
            初めての方
          </li>
          <li
            @click="routerPush('serviceFeatures')"
            :class="{ 'active': currentServiceMenu === 'serviceFeatures' }"
          >
            機能一覧
          </li>
          <li
            @click="routerPush('servicePlans')"
            :class="{ 'active': currentServiceMenu === 'servicePlans' }"
          >
            料金プラン
          </li>
          <li
            @click="routerPush('indexServiceNotifications')"
            :class="{ 'active': currentServiceMenu.endsWith('ServiceNotifications') }"
          >
            お知らせ
          </li>
          <template v-if="!signedIn">
            <li class="sign-in" @click="routerPush('signIn')">
              ログイン
            </li>
            <li class="sign-up" @click="routerPush('signUp')">
              無料アカウントを作成
            </li>
          </template>
          <template v-else>
            <li class="sign-up" @click="routerPush('mySpace')">
              マイスペース
            </li>
          </template>
        </ul>
      </nav>
      <div :class="['clickable burger-menu-btn', {'active': isOpen}]" @click="toggleBurgerMenu">
        <span />
        <span />
        <span />
      </div>
      <transition name="slide" v-if="isOpen" appear>
        <nav class="nav-wrapper sp">
          <ul>
            <li @click="routerPush('serviceAbout')">
              初めての方
            </li>
            <li @click="routerPush('serviceFeatures')">
              機能一覧
            </li>
            <li @click="routerPush('servicePlans')">
              料金プラン
            </li>
            <li @click="routerPush('indexServiceNotifications')">
              お知らせ
            </li>
            <template v-if="!signedIn">
              <li @click="routerPush('signIn')">
                ログイン
              </li>
              <li class="sign-up" @click="routerPush('signUp')">
                無料アカウントを作成
              </li>
            </template>
            <template v-else>
              <li class="sign-up" @click="routerPush('mySpace')">
                マイスペース
              </li>
            </template>
          </ul>
        </nav>
      </transition>
    </div>
  </header>
</template>

<script>
export default {
  name: 'ServiceHeader',
  props: {
    signedIn: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentServiceMenu: function() {
      return this.$route.name
    }
  },
  data () {
    return {
      logoSrc: require('@/assets/images/logo.png'),
      isOpen: false
    }
  },
  methods: {
    toggleBurgerMenu: function() {
      this.isOpen = !this.isOpen
      if (this.isOpen) {
        this.logoSrc = require('@/assets/images/logo_white.png')
        document.body.style.overflow = 'hidden'
      } else {
        this.logoSrc = require('@/assets/images/logo.png')
        document.body.style.overflow = 'visible'
      }
    },
    closeBurgerMenu: function() {
      this.isOpen = false
      this.logoSrc = require('@/assets/images/logo.png')
      document.body.style.overflow = 'visible'
    },
    routerPush: function(route = null) {
      if (this.$route.name === route) return
      this.closeBurgerMenu()
      if (!route) {
        this.$router.push({ name: 'root' })
      } else {
        this.$router.push({ name: `${route}` })
      }
    },
    toServiceTop: function() {
      if (this.$route.name === 'service') return
      this.closeBurgerMenu()
      this.$router.push({ name: 'service' })
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/mediaquery";

.service-header {
  position: fixed;
  top: 0;
  background-color: #fff;
  width: 100vw;
  z-index: 2;

  &-inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 70px;

    .logo-wrapper {
      position: relative;
      z-index: 3;
      margin-left: 20px;
      transition: all .2s;

      @include mq(lg) {
        margin-left: 50px;
      }

      &:hover {
        opacity: .6;
      }

      img {
        width: 140px;
      }
    }

    .nav-wrapper {

      ul {
        display: flex;

        li {
          list-style: none;
          cursor: pointer;
          word-break: keep-all;
        }
      }
      &.pc {
        display: none;

        @include mq(md) {
          display: block;

          ul {
            align-items: center;
            margin-bottom: 0;

            li {
              position: relative;
              height: 70px;
              display: flex;
              align-items: center;
              color: #000;
              font-size: 12px;
              font-weight: 600;
              margin-right: 10px;
              transition: all .2s;

              @include mq(lg) {
                font-size: 13px;
                font-weight: bold;
                margin-right: 20px;
              }

              @media screen and (min-width: 1150px) {
                font-size: 16px;
                margin-right: 40px;
              }

              &.active:after{
                content: "";
                display: block;
                width: 100%;
                height: 6px;
                background-color: $service-primary-color;
                position: absolute;
                bottom: 0;
              }

              &:last-child {
                margin-right: 0;
              }

              &:hover {
                color: $service-primary-color;
              }

              &.sign-in {
                color: $service-primary-color;
              }

              &.sign-up {
                background-color: $service-primary-color;
                color: white;
                padding: 0 20px;

                @include mq(lg) {
                  padding: 0 40px;
                }

                &:hover {
                  background-color: #fff;
                  color: $service-primary-color;
                }
              }
            }
          }
        }
      }

      &.sp {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 2;
        display: block;
        background-color: $service-primary-color;
        height: 100vh;
        width: 100vw;

        ul {
          flex-direction: column;
          margin-top: 170px;
          padding-left: 20px;

          li {
            color: #fff;
            font-size: 16px;
            font-weight: bold;
            border-bottom: 1px solid white;
            margin-bottom: 20px;
            padding-bottom: 10px;
            width: 60%;

            &.sign-up {
              text-align: center;
              color: $service-primary-color;
              background-color: white;
              border-radius: 4px;
              border-bottom: none;
              margin-bottom: 0;
              padding: 10px 20px;
            }
          }
        }

        @include mq(md) {
          display: none;
        }
      }
    }

    .burger-menu-btn {
      position: absolute;
      top: 20px;
      right: 20px;
      display: block;
      height: 44px;
      width: 35px;
      z-index: 3;

      @include mq(md) {
        display: none;
      }

      span {
        position: absolute;
        left: 0;
        width: 100%;
        height: 3px;
        background-color: $service-primary-color;
        border-radius: 4px;
        transition: all .5s;

        &:nth-of-type(1) {
          top: 5px;
        }
        &:nth-of-type(2) {
          top: 15px;
        }
        &:nth-of-type(3) {
          bottom: 15px;
        }
      }

      &.active {
        span {
          background-color: #fff;

          &:nth-of-type(1) {
            transform: translateY(12px) rotate(-45deg);
          }
          &:nth-of-type(2) {
            opacity: 0;
          }
          &:nth-of-type(3) {
            transform: translateY(-9px) rotate(45deg);
          }
        }
      }
    }

    .slide-enter-active, .slide-leave-active {
      transform: translate(0px, 0px);
      transition: transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;
    }
    .slide-enter, .slide-leave-to {
      transform: translateX(100vw) translateX(0px);
    }
  }
}
</style>
